import {FC, forwardRef, useState} from "react";
import classNames from "classnames";

import ShowPassword from "../../../../public/images/showPassword.svg";
import HidePassword from "../../../../public/images/hidePassword.svg";

type Props = {
    label?: string;
    error: any;
    // | string
    // | FieldError
    // | Merge<FieldError, FieldErrorsImpl<any>>
    // | boolean;
    autoComplete?: string;
    required?: boolean;
    identifier?: string;
    placeholder?: string;
    t?: any;
};

const PasswordField: FC<Props> = forwardRef(
    (
        {
            label = "Password",
            error,
            identifier = "password",
            placeholder,
            t,
            ...rest
        }: Props,
        ref: any,
    ) => {
        const [show, setShow] = useState(false);

        return (
            <div>
                <label htmlFor={identifier} className="block mb-3">
                    <span className="text-sm text-[#031F47] font-semibold">{label}</span>
                </label>
                <div>
                    <div className="relative">
                        <input
                            ref={ref}
                            {...rest}
                            type={show ? "text" : "password"}
                            id={identifier}
                            placeholder={placeholder}
                            className={classNames(
                                "block w-full appearance-none rounded-lg border px-3 py-[13px] leading-[140%] text-neutral-1000 font-medium focus:outline-none text-sm",
                                {
                                    "border-red-500 focus:border-red-500 focus:ring-red-500":
                                    error,
                                    "border-neutral-400 focus:border-primary-800 focus:ring-primary-800":
                                        !error,
                                },
                            )}
                        />
                        {show ? (
                            <HidePassword
                                onClick={() => setShow((val) => !val)}
                                className="text-gray-700 cursor-pointer absolute bottom-1/2 translate-y-1/2 right-3"
                                alt="Hide password"
                                width={18}
                                height={14}
                            />
                        ) : (
                            <ShowPassword
                                onClick={() => setShow((val) => !val)}
                                className="text-gray-700 cursor-pointer absolute bottom-1/2 translate-y-1/2 right-3"
                                alt="Show password"
                                width={18}
                                height={14}
                            />
                        )}
                    </div>
                    {error && (
                        <span className="text-red-500 text-xs">
              {t ? t(error.message) : error.message}
            </span>
                    )}
                </div>
            </div>
        );
    },
);

export {PasswordField};
